module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-plans"
  }, [(_vm.subscribePlans.length) ? _c('ul', {
    staticClass: "box-group ls-md-margin-bottom"
  }, [_vm._l((_vm.plans), function(plan) {
    return _c('box-info', {
      key: plan,
      staticClass: "col-md-4",
      class: {
        'suggested-plan': plan.suggested
      }
    }, [(plan.suggested) ? _c('div', {
      staticClass: "ribbon ribbon-top-right",
      slot: "suggested"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('subscribe.attributes.suggested')))])]) : _vm._e(), _vm._v(" "), _c('h6', {
      staticClass: "ls-text-xl",
      slot: "title"
    }, [_vm._v(_vm._s(plan.name))]), _vm._v(" "), _c('h3', {
      slot: "value"
    }, [_vm._v("R$ "), _c('span', [_vm._v(_vm._s(_vm.money.parseViewValue(plan.price)))])]), _vm._v(" "), (plan.periodicity === 1) ? _c('p', {
      slot: "periodicity"
    }, [_vm._v("Cobrado mensalmente")]) : _c('p', {
      slot: "periodicity"
    }, [_vm._v("Cobrado uma vez a cada " + _vm._s(plan.periodicity) + " meses")]), _vm._v(" "), _c('p', {
      staticClass: "plan-description",
      slot: "description"
    }, [_vm._v(_vm._s(plan.description))]), _vm._v(" "), _c('footer', {
      staticClass: "ls-box-footer",
      slot: "footer"
    }, [_c('button', {
      staticClass: "ls-btn ls-btn-lg ls-full-width",
      class: [plan.suggested ? 'ls-btn-primary' : 'btn-custom'],
      on: {
        "click": function($event) {
          _vm.step(plan)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('subscribe.buttons.hire')))])])])
  }), _vm._v(" "), (_vm.loadMore && _vm.allPlans > 0) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-2x fa-fw ls-full-width ls-display-block"
  }) : _vm._e(), _vm._v(" "), (_vm.allPlans === 0) ? _c('p', {
    staticClass: "ls-full-width ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('subscribe.messages.showing_total')) + "  " + _vm._s(_vm.subscribePlans.length) + " " + _vm._s(_vm.$t('subscribe.attributes.plans')))]) : _vm._e()], 2) : _c('p', {
    staticClass: "ls-txt-center-all"
  }, [_vm._v(_vm._s(_vm.$t('subscribe.attributes.plan_not_found')))]), _vm._v(" "), (_vm.autoLoad) ? _c('div', [_c('button', {
    staticClass: "ls-btn ls-btn-lg ls-btn-primary ls-md-margin-bottom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadAll
    }
  }, [_vm._v(_vm._s(_vm.$t('subscribe.buttons.load_more_planes')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f5ddc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/subscribe/Plan.vue
// module id = 720
// module chunks = 1